export const feedback = {
  "v": "5.9.6",
  "fr": 60,
  "ip": 0,
  "op": 120,
  "w": 750,
  "h": 750,
  "nm": "Comp 1",
  "ddd": 0,
  "assets": [],
  "layers": [
    {
      "ddd": 0,
      "ind": 1,
      "ty": 4,
      "nm": "Layer 1",
      "sr": 1,
      "ks": {
        "o": {
          "a": 0,
          "k": 100,
          "ix": 11
        },
        "r": {
          "a": 0,
          "k": 0,
          "ix": 10
        },
        "p": {
          "a": 0,
          "k": [
            375,
            375,
            0
          ],
          "ix": 2,
          "l": 2
        },
        "a": {
          "a": 0,
          "k": [
            512.006,
            517.961,
            0
          ],
          "ix": 1,
          "l": 2
        },
        "s": {
          "a": 0,
          "k": [
            100,
            100,
            100
          ],
          "ix": 6,
          "l": 2
        }
      },
      "ao": 0,
      "shapes": [
        {
          "ty": "gr",
          "it": [
            {
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 1,
                "k": [
                  {
                    "i": {
                      "x": 0.39,
                      "y": 1
                    },
                    "o": {
                      "x": 0.61,
                      "y": 0
                    },
                    "t": 0,
                    "s": [
                      {
                        "i": [
                          [
                            141.406,
                            31.433
                          ],
                          [
                            46.927,
                            31.433
                          ],
                          [
                            -1.747,
                            133.546
                          ],
                          [
                            -22.911,
                            153.635
                          ],
                          [
                            -35.958,
                            146.012
                          ],
                          [
                            -66.445,
                            111.24000000000001
                          ],
                          [
                            -45.017,
                            31.433
                          ],
                          [
                            -112.969,
                            31.433
                          ],
                          [
                            -143.316,
                            17.634999999999998
                          ],
                          [
                            -125.6,
                            -111.859
                          ],
                          [
                            -102.864,
                            -149.311
                          ],
                          [
                            141.406,
                            -149.04
                          ]
                        ],
                        "o": [
                          [
                            141.406,
                            31.433
                          ],
                          [
                            46.927,
                            31.433
                          ],
                          [
                            -5.575,
                            147.317
                          ],
                          [
                            -35.957,
                            146.012
                          ],
                          [
                            -56.524,
                            133.995
                          ],
                          [
                            -60.604,
                            89.486
                          ],
                          [
                            -45.017,
                            31.433
                          ],
                          [
                            -130.081,
                            31.433
                          ],
                          [
                            -141.18,
                            2.022
                          ],
                          [
                            -122.672,
                            -133.264
                          ],
                          [
                            -79.404,
                            -149.285
                          ],
                          [
                            141.406,
                            -149.04
                          ]
                        ],
                        "v": [
                          [
                            141.406,
                            31.433
                          ],
                          [
                            46.927,
                            31.433
                          ],
                          [
                            -1.747,
                            133.546
                          ],
                          [
                            -35.957,
                            146.012
                          ],
                          [
                            -35.958,
                            146.012
                          ],
                          [
                            -60.604,
                            89.486
                          ],
                          [
                            -45.017,
                            31.433
                          ],
                          [
                            -112.969,
                            31.433
                          ],
                          [
                            -141.18,
                            2.022
                          ],
                          [
                            -125.6,
                            -111.859
                          ],
                          [
                            -79.404,
                            -149.285
                          ],
                          [
                            141.406,
                            -149.04
                          ]
                        ],
                        "c": true
                      }
                    ]
                  },
                  {
                    "i": {
                      "x": 0.39,
                      "y": 1
                    },
                    "o": {
                      "x": 0.61,
                      "y": 0
                    },
                    "t": 25,
                    "s": [
                      {
                        "i": [
                          [
                            141.406,
                            31.433
                          ],
                          [
                            46.927,
                            31.433
                          ],
                          [
                            14.253,
                            83.546
                          ],
                          [
                            -6.911000000000001,
                            103.635
                          ],
                          [
                            -19.958,
                            96.012
                          ],
                          [
                            -50.445,
                            61.239999999999995
                          ],
                          [
                            -45.017,
                            31.433
                          ],
                          [
                            -112.969,
                            31.433
                          ],
                          [
                            -143.316,
                            17.636
                          ],
                          [
                            -125.6,
                            -111.859
                          ],
                          [
                            -102.864,
                            -149.311
                          ],
                          [
                            141.406,
                            -149.04
                          ]
                        ],
                        "o": [
                          [
                            141.406,
                            31.433
                          ],
                          [
                            46.927,
                            31.433
                          ],
                          [
                            10.425,
                            97.31700000000001
                          ],
                          [
                            -19.957,
                            96.012
                          ],
                          [
                            -40.524,
                            83.995
                          ],
                          [
                            -44.604,
                            39.486
                          ],
                          [
                            -45.017,
                            31.433
                          ],
                          [
                            -130.081,
                            31.433
                          ],
                          [
                            -141.18,
                            2.023
                          ],
                          [
                            -122.672,
                            -133.264
                          ],
                          [
                            -79.404,
                            -149.285
                          ],
                          [
                            141.406,
                            -149.04
                          ]
                        ],
                        "v": [
                          [
                            141.406,
                            31.433
                          ],
                          [
                            46.927,
                            31.433
                          ],
                          [
                            14.253,
                            83.546
                          ],
                          [
                            -19.957,
                            96.012
                          ],
                          [
                            -19.958,
                            96.012
                          ],
                          [
                            -44.604,
                            39.486
                          ],
                          [
                            -45.017,
                            31.433
                          ],
                          [
                            -112.969,
                            31.433
                          ],
                          [
                            -141.18,
                            2.023
                          ],
                          [
                            -125.6,
                            -111.859
                          ],
                          [
                            -79.404,
                            -149.285
                          ],
                          [
                            141.406,
                            -149.04
                          ]
                        ],
                        "c": true
                      }
                    ]
                  },
                  {
                    "t": 50,
                    "s": [
                      {
                        "i": [
                          [
                            141.406,
                            31.433
                          ],
                          [
                            46.927,
                            31.433
                          ],
                          [
                            -1.747,
                            133.546
                          ],
                          [
                            -22.911,
                            153.635
                          ],
                          [
                            -35.958,
                            146.012
                          ],
                          [
                            -66.445,
                            111.24000000000001
                          ],
                          [
                            -45.017,
                            31.433
                          ],
                          [
                            -112.969,
                            31.433
                          ],
                          [
                            -143.316,
                            17.634999999999998
                          ],
                          [
                            -125.6,
                            -111.859
                          ],
                          [
                            -102.864,
                            -149.311
                          ],
                          [
                            141.406,
                            -149.04
                          ]
                        ],
                        "o": [
                          [
                            141.406,
                            31.433
                          ],
                          [
                            46.927,
                            31.433
                          ],
                          [
                            -5.575,
                            147.317
                          ],
                          [
                            -35.957,
                            146.012
                          ],
                          [
                            -56.524,
                            133.995
                          ],
                          [
                            -60.604,
                            89.486
                          ],
                          [
                            -45.017,
                            31.433
                          ],
                          [
                            -130.081,
                            31.433
                          ],
                          [
                            -141.18,
                            2.022
                          ],
                          [
                            -122.672,
                            -133.264
                          ],
                          [
                            -79.404,
                            -149.285
                          ],
                          [
                            141.406,
                            -149.04
                          ]
                        ],
                        "v": [
                          [
                            141.406,
                            31.433
                          ],
                          [
                            46.927,
                            31.433
                          ],
                          [
                            -1.747,
                            133.546
                          ],
                          [
                            -35.957,
                            146.012
                          ],
                          [
                            -35.958,
                            146.012
                          ],
                          [
                            -60.604,
                            89.486
                          ],
                          [
                            -45.017,
                            31.433
                          ],
                          [
                            -112.969,
                            31.433
                          ],
                          [
                            -141.18,
                            2.022
                          ],
                          [
                            -125.6,
                            -111.859
                          ],
                          [
                            -79.404,
                            -149.285
                          ],
                          [
                            141.406,
                            -149.04
                          ]
                        ],
                        "c": true
                      }
                    ]
                  }
                ],
                "ix": 2
              },
              "nm": "Path 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false,
              "_render": true
            },
            {
              "ty": "st",
              "c": {
                "a": 0,
                "k": [
                  0,
                  0,
                  0,
                  1
                ],
                "ix": 3
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 4
              },
              "w": {
                "a": 0,
                "k": 35,
                "ix": 5
              },
              "lc": 2,
              "lj": 2,
              "bm": 0,
              "nm": "Stroke 1",
              "mn": "ADBE Vector Graphic - Stroke",
              "hd": false,
              "_render": true
            },
            {
              "ty": "tr",
              "p": {
                "a": 0,
                "k": [
                  639.499,
                  431.785
                ],
                "ix": 2
              },
              "a": {
                "a": 0,
                "k": [
                  0,
                  0
                ],
                "ix": 1
              },
              "s": {
                "a": 0,
                "k": [
                  100,
                  100
                ],
                "ix": 3
              },
              "r": {
                "a": 0,
                "k": 0,
                "ix": 6
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 7
              },
              "sk": {
                "a": 0,
                "k": 0,
                "ix": 4
              },
              "sa": {
                "a": 0,
                "k": 0,
                "ix": 5
              },
              "nm": "Transform",
              "_render": true
            }
          ],
          "nm": "Group 1",
          "np": 2,
          "cix": 2,
          "bm": 0,
          "ix": 1,
          "mn": "ADBE Vector Group",
          "hd": false,
          "_render": true
        },
        {
          "ty": "gr",
          "it": [
            {
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 1,
                "k": [
                  {
                    "i": {
                      "x": 0.39,
                      "y": 1
                    },
                    "o": {
                      "x": 0.61,
                      "y": 0
                    },
                    "t": 0,
                    "s": [
                      {
                        "i": [
                          [
                            -141.406,
                            -31.433
                          ],
                          [
                            -46.927,
                            -31.433
                          ],
                          [
                            1.747,
                            -133.546
                          ],
                          [
                            22.911,
                            -153.635
                          ],
                          [
                            35.958,
                            -146.012
                          ],
                          [
                            66.445,
                            -111.24000000000001
                          ],
                          [
                            45.017,
                            -31.433
                          ],
                          [
                            112.969,
                            -31.433
                          ],
                          [
                            143.316,
                            -17.634999999999998
                          ],
                          [
                            125.6,
                            111.859
                          ],
                          [
                            102.864,
                            149.311
                          ],
                          [
                            -141.406,
                            149.04
                          ]
                        ],
                        "o": [
                          [
                            -141.406,
                            -31.433
                          ],
                          [
                            -46.927,
                            -31.433
                          ],
                          [
                            5.575,
                            -147.317
                          ],
                          [
                            35.957,
                            -146.012
                          ],
                          [
                            56.524,
                            -133.995
                          ],
                          [
                            60.604,
                            -89.486
                          ],
                          [
                            45.017,
                            -31.433
                          ],
                          [
                            130.081,
                            -31.433
                          ],
                          [
                            141.18,
                            -2.022
                          ],
                          [
                            122.672,
                            133.264
                          ],
                          [
                            79.404,
                            149.285
                          ],
                          [
                            -141.406,
                            149.04
                          ]
                        ],
                        "v": [
                          [
                            -141.406,
                            -31.433
                          ],
                          [
                            -46.927,
                            -31.433
                          ],
                          [
                            1.747,
                            -133.546
                          ],
                          [
                            35.957,
                            -146.012
                          ],
                          [
                            35.958,
                            -146.012
                          ],
                          [
                            60.604,
                            -89.486
                          ],
                          [
                            45.017,
                            -31.433
                          ],
                          [
                            112.969,
                            -31.433
                          ],
                          [
                            141.18,
                            -2.022
                          ],
                          [
                            125.6,
                            111.859
                          ],
                          [
                            79.404,
                            149.285
                          ],
                          [
                            -141.406,
                            149.04
                          ]
                        ],
                        "c": true
                      }
                    ]
                  },
                  {
                    "i": {
                      "x": 0.39,
                      "y": 1
                    },
                    "o": {
                      "x": 0.61,
                      "y": 0
                    },
                    "t": 25,
                    "s": [
                      {
                        "i": [
                          [
                            -141.406,
                            -31.433
                          ],
                          [
                            -46.927,
                            -31.433
                          ],
                          [
                            -12.253,
                            -81.546
                          ],
                          [
                            8.911000000000001,
                            -101.635
                          ],
                          [
                            21.958,
                            -94.012
                          ],
                          [
                            52.445,
                            -59.239999999999995
                          ],
                          [
                            45.017,
                            -31.433
                          ],
                          [
                            112.969,
                            -31.433
                          ],
                          [
                            143.316,
                            -17.634999999999998
                          ],
                          [
                            125.6,
                            111.859
                          ],
                          [
                            102.864,
                            149.311
                          ],
                          [
                            -141.406,
                            149.04
                          ]
                        ],
                        "o": [
                          [
                            -141.406,
                            -31.433
                          ],
                          [
                            -46.927,
                            -31.433
                          ],
                          [
                            -8.425,
                            -95.31700000000001
                          ],
                          [
                            21.957,
                            -94.012
                          ],
                          [
                            42.524,
                            -81.995
                          ],
                          [
                            46.604,
                            -37.486
                          ],
                          [
                            45.017,
                            -31.433
                          ],
                          [
                            130.081,
                            -31.433
                          ],
                          [
                            141.18,
                            -2.022
                          ],
                          [
                            122.672,
                            133.264
                          ],
                          [
                            79.404,
                            149.285
                          ],
                          [
                            -141.406,
                            149.04
                          ]
                        ],
                        "v": [
                          [
                            -141.406,
                            -31.433
                          ],
                          [
                            -46.927,
                            -31.433
                          ],
                          [
                            -12.253,
                            -81.546
                          ],
                          [
                            21.957,
                            -94.012
                          ],
                          [
                            21.958,
                            -94.012
                          ],
                          [
                            46.604,
                            -37.486
                          ],
                          [
                            45.017,
                            -31.433
                          ],
                          [
                            112.969,
                            -31.433
                          ],
                          [
                            141.18,
                            -2.022
                          ],
                          [
                            125.6,
                            111.859
                          ],
                          [
                            79.404,
                            149.285
                          ],
                          [
                            -141.406,
                            149.04
                          ]
                        ],
                        "c": true
                      }
                    ]
                  },
                  {
                    "t": 50,
                    "s": [
                      {
                        "i": [
                          [
                            -141.406,
                            -31.433
                          ],
                          [
                            -46.927,
                            -31.433
                          ],
                          [
                            1.747,
                            -133.546
                          ],
                          [
                            22.911,
                            -153.635
                          ],
                          [
                            35.958,
                            -146.012
                          ],
                          [
                            66.445,
                            -111.24000000000001
                          ],
                          [
                            45.017,
                            -31.433
                          ],
                          [
                            112.969,
                            -31.433
                          ],
                          [
                            143.316,
                            -17.634999999999998
                          ],
                          [
                            125.6,
                            111.859
                          ],
                          [
                            102.864,
                            149.311
                          ],
                          [
                            -141.406,
                            149.04
                          ]
                        ],
                        "o": [
                          [
                            -141.406,
                            -31.433
                          ],
                          [
                            -46.927,
                            -31.433
                          ],
                          [
                            5.575,
                            -147.317
                          ],
                          [
                            35.957,
                            -146.012
                          ],
                          [
                            56.524,
                            -133.995
                          ],
                          [
                            60.604,
                            -89.486
                          ],
                          [
                            45.017,
                            -31.433
                          ],
                          [
                            130.081,
                            -31.433
                          ],
                          [
                            141.18,
                            -2.022
                          ],
                          [
                            122.672,
                            133.264
                          ],
                          [
                            79.404,
                            149.285
                          ],
                          [
                            -141.406,
                            149.04
                          ]
                        ],
                        "v": [
                          [
                            -141.406,
                            -31.433
                          ],
                          [
                            -46.927,
                            -31.433
                          ],
                          [
                            1.747,
                            -133.546
                          ],
                          [
                            35.957,
                            -146.012
                          ],
                          [
                            35.958,
                            -146.012
                          ],
                          [
                            60.604,
                            -89.486
                          ],
                          [
                            45.017,
                            -31.433
                          ],
                          [
                            112.969,
                            -31.433
                          ],
                          [
                            141.18,
                            -2.022
                          ],
                          [
                            125.6,
                            111.859
                          ],
                          [
                            79.404,
                            149.285
                          ],
                          [
                            -141.406,
                            149.04
                          ]
                        ],
                        "c": true
                      }
                    ]
                  }
                ],
                "ix": 2
              },
              "nm": "Path 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false,
              "_render": true
            },
            {
              "ty": "st",
              "c": {
                "a": 0,
                "k": [
                  0,
                  0,
                  0,
                  1
                ],
                "ix": 3
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 4
              },
              "w": {
                "a": 0,
                "k": 35,
                "ix": 5
              },
              "lc": 2,
              "lj": 2,
              "bm": 0,
              "nm": "Stroke 1",
              "mn": "ADBE Vector Graphic - Stroke",
              "hd": false,
              "_render": true
            },
            {
              "ty": "tr",
              "p": {
                "a": 0,
                "k": [
                  384.513,
                  604.136
                ],
                "ix": 2
              },
              "a": {
                "a": 0,
                "k": [
                  0,
                  0
                ],
                "ix": 1
              },
              "s": {
                "a": 0,
                "k": [
                  100,
                  100
                ],
                "ix": 3
              },
              "r": {
                "a": 0,
                "k": 0,
                "ix": 6
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 7
              },
              "sk": {
                "a": 0,
                "k": 0,
                "ix": 4
              },
              "sa": {
                "a": 0,
                "k": 0,
                "ix": 5
              },
              "nm": "Transform",
              "_render": true
            }
          ],
          "nm": "Group 2",
          "np": 2,
          "cix": 2,
          "bm": 0,
          "ix": 2,
          "mn": "ADBE Vector Group",
          "hd": false,
          "_render": true
        }
      ],
      "ip": 0,
      "op": 120,
      "st": 0,
      "ct": 1,
      "bm": 0,
      "completed": true
    }
  ],
  "markers": [],
  "__complete": true
}